<button mat-mini-fab [matMenuTriggerFor]="profile" class="button-perfil" aria-label="Perfil">
  <mat-icon>account_circle</mat-icon>
</button>

<mat-menu #profile="matMenu" class="menu-perfil" xPosition="before">
  <!-- Cabecera con datos del usuario -->
  <div class="perfil-header" (click)="$event.stopPropagation()">
    <div class="perfil-avatar">{{dataUsuario?.Usuario | slice:0:2}}</div>
    <div class="perfil-info">
      <div class="perfil-nombre">{{dataUsuario?.Usuario}}</div>
      <div class="perfil-rol">{{dataUsuario?.TipoUsuario}}</div>
    </div>
  </div>

  <div class="perfil-divisor"></div>


  <button mat-menu-item class="perfil-item" (click)="authServices.CerrarSesion()">
    <mat-icon>logout</mat-icon>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>